import { FC, useState } from 'react';

import { CompareRule, RequiredRule } from 'devextreme-react/cjs/form';
import { DropDownOptions } from 'devextreme-react/cjs/select-box';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox, TextBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { AccountCreate } from 'pages/Accounts/Accounts.entity';

type Props = {
  employeeDateSource: DataSource;
  roleSource: DataSource;
  form: AccountCreate;
  onChange: (name: keyof AccountCreate, value: AccountCreate[keyof AccountCreate]) => void;
};

export const AccountCreateForm: FC<Props> = ({ employeeDateSource, roleSource, form, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div>
      <AppFieldBox label="ФИО" labelTop>
        <SelectBox
          stylingMode="underlined"
          dataSource={employeeDateSource}
          displayExpr="fullName"
          valueExpr="id"
          value={form.employeeId}
          searchEnabled
          onItemClick={(e) => {
            onChange('employeeId', e.itemData.id);
          }}
        >
          <DropDownOptions title="Выберите контрагента" closeOnOutsideClick={true} showTitle={false} />
          <Validator>
            <RequiredRule message="Выберите контрагента" />
          </Validator>
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Роль" labelTop>
        <SelectBox
          stylingMode="underlined"
          style={{ width: '100%' }}
          placeholder="Выберите роль"
          mode="text"
          value={form.roleId}
          onItemClick={(e) => {
            onChange('roleId', e.itemData.id);
          }}
          displayExpr="name"
          searchEnabled={true}
          searchExpr={['name']}
          dataSource={roleSource}
        >
          <Validator>
            <RequiredRule message="Выберите роль" />
          </Validator>
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Логин" labelTop>
        <TextBox
          stylingMode="underlined"
          placeholder="Введите логин"
          mode="text"
          value={form.userName}
          onValueChange={(e) => onChange('userName', e)}
        >
          <Validator>
            <RequiredRule message="Заполните поле логин" />
          </Validator>
        </TextBox>
      </AppFieldBox>

      <AppFieldBox label="Пароль" labelTop>
        <TextBox
          stylingMode="underlined"
          placeholder="Введите пароль"
          value={form.password}
          onValueChange={(e) => onChange('password', e)}
          mode={showPassword ? 'text' : 'password'}
          buttons={[
            {
              name: 'togglePassword',
              location: 'after',
              options: {
                //stylingMode: 'text',
                icon: showPassword ? 'eyeclose' : 'eyeopen',
                onClick: () => setShowPassword((prev) => !prev),
              },
            },
          ]}
        >
          <Validator>
            <RequiredRule message="Заполните поле Пароль" />
          </Validator>
        </TextBox>
      </AppFieldBox>
      <AppFieldBox label="Подтвердите пароль" labelTop>
        <TextBox
          value={form.confirmPassword}
          onValueChange={(e) => onChange('confirmPassword', e)}
          stylingMode="underlined"
          placeholder="Подтвердите пароль"
          mode={showConfirmPassword ? 'text' : 'password'}
          //showClearButton
          buttons={[
            {
              name: 'toggleConfirmPassword',
              location: 'after',
              options: {
                //stylingMode: 'text',
                icon: showConfirmPassword ? 'eyeclose' : 'eyeopen',
                onClick: () => setShowConfirmPassword((prev) => !prev),
              },
            },
          ]}
        >
          <Validator>
            <RequiredRule message="Подтверждение пароля обязательно" />
            <CompareRule comparisonTarget={() => form.password} message="Пароли должны совпадать" />
          </Validator>
        </TextBox>
      </AppFieldBox>
    </div>
  );
};
